const isActiveFilter = {
  namespaced: true,
  state: {
    data: null
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    setData(context, value) {
      context.commit("SET_DATA", value);
    }
  },
  getters: {
    data: state => {
      return state.data;
    },
    toParams: state => {
      return [
        { column: "active", value: state.data }
      ];
    }
  }
};

export default isActiveFilter;
